import { render, staticRenderFns } from "./Dashboard1.vue?vue&type=template&id=9e64f36a&scoped=true&"
import script from "./Dashboard1.vue?vue&type=script&lang=js&"
export * from "./Dashboard1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e64f36a",
  null
  
)

export default component.exports